import React from "react";
import { Link, useLocation } from "react-router-dom";

const ServiceArea = [
  {
    label: "Tozkoparan Mahallesi Halı Yıkama",
    path: "/gungoren/tozkoparan-hali-yikama",
    description:
      "Tozkoparan Mahallesi’nde halılarınız profesyonel ekiplerle el değmeden, antibakteriyel şekilde temizlenir."
  },
  {
    label: "Merter Halı Yıkama",
    path: "/gungoren/merter-hali-yikama",
    description:
      "Merter semtinde bireysel ve ticari müşterilere yönelik hızlı, hijyenik ve garantili halı yıkama hizmeti sunuyoruz."
  },
  {
    label: "Sanayi Mahallesi Halı Yıkama",
    path: "/gungoren/sanayi-hali-yikama",
    description:
      "Sanayi Mahallesi'nde tam otomatik makinelerde hijyen odaklı halı yıkama işlemleri gerçekleştirilir."
  },
  {
    label: "Güneştepe Mahallesi Halı Yıkama",
    path: "/gungoren/gunestepe-hali-yikama",
    description:
      "Güneştepe bölgesine özel ücretsiz servisimizle halılarınızı evden alıp en kısa sürede teslim ediyoruz."
  },
  {
    label: "Haznedar Halı Yıkama",
    path: "/gungoren/haznedar-hali-yikama",
    description:
      "Haznedar semtinde halılarınız modern teknolojiyle yıkanır, özenle paketlenerek kapınıza getirilir."
  },
  {
    label: "Gençosman Mahallesi Halı Yıkama",
    path: "/gungoren/gencosman-hali-yikama",
    description:
      "Gençosman Mahallesi’nde organik temizlik ürünleriyle sağlıklı halı yıkama hizmeti sunmaktayız."
  },
  {
    label: "Mareşal Çakmak Mahallesi Halı Yıkama",
    path: "/gungoren/maresal-cakmak-hali-yikama",
    description:
      "Mareşal Çakmak Mahallesi’nde halılarınızı tam hijyen garantili şekilde yıkayıp zamanında teslim ediyoruz."
  }
];

const GungorenSidebar = () => {
  const location = useLocation();

  return (
    <div className="mt-2 text-[#003132]">
      <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">GÜNGÖREN SERVİS ALANLARI</h2>

      <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm space-y-3 border border-gray-200">
        {ServiceArea.map((area, index) => (
          <div key={index}>
            <Link
              to={area.path}
              className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-red-600 text-white"
                  : "text-red-900 hover:bg-green-100 hover:text-red-800"
              }`}
            >
              {area.label}
            </Link>
            <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GungorenSidebar;
